import { Component } from '@angular/core';

@Component({
  selector: 'app-student-counselling-details-link',
  templateUrl: './student-counselling-details-link.component.html',
  styleUrls: ['./student-counselling-details-link.component.scss']
})
export class StudentCounsellingDetailsLinkComponent {

}
